import * as THREE from "three";

export function lerp(a, b, t) {
    return ((1 - t) * a + t * b);
}

export function lerp3(a, b, t)  {

    var x = lerp(a.x, b.x, t);
    var y = lerp(a.y, b.y, t);
    var z = lerp(a.z, b.z, t);

    return new THREE.Vector3(x, y, z);

}

export function setAnimationsCondition(scrollPosition, scrollDirection, valueAtIndex)  {

    var scrollInRange = scrollPosition >= valueAtIndex && scrollPosition <= valueAtIndex + 0.01;
    var scrollGreater = scrollPosition > valueAtIndex;
    var direction = scrollDirection;

    return {
        scrollInRange: scrollInRange,
        scrollGreater: scrollGreater,
        direction:direction
    };


}



